import React from 'react';
import { Users } from 'lucide-react';

const PhotoGallery = () => {
  const photos = [
    {
      src: '/images/academy/live-training.jpg',
      alt: 'Students learning live market analysis',
      title: 'Live Market Training',
      description: 'Students analyzing real-time charts and learning practical strategies'
    },
    {
      src: '/images/academy/classroom.jpg',
      alt: 'Professional classroom environment',
      title: 'Modern Classroom',
      description: 'Well-equipped training space with individual workstations'
    },
    {
      src: '/images/academy/students-certificates.jpg',
      alt: 'Successful students with certificates',
      title: 'Course Completion',
      description: 'Our proud students after successfully completing their training'
    }
  ];

  return (
    <section className="py-16 sm:py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="max-w-3xl mx-auto text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-green-100 rounded-full mb-4">
            <Users className="h-4 w-4 text-green-700" />
            <span className="text-sm font-semibold text-green-700">Inside Our Academy</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            See Our <span className="text-green-600">Training Environment</span>
          </h2>
          <p className="text-lg text-gray-600">
            Get a glimpse of our professional training setup and successful students
          </p>
        </div>

        {/* Photo Grid */}
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {photos.map((photo) => (
              <div 
                key={photo.title}
                className="group relative overflow-hidden rounded-xl border-2 border-green-200 hover:border-green-600 transition-all duration-300 hover:shadow-2xl"
              >
                {/* Image */}
                <div className="aspect-[4/3] overflow-hidden">
                  <img 
                    src={photo.src}
                    alt={photo.alt}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                
                {/* Overlay Content */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                    <h3 className="text-xl font-bold mb-2">{photo.title}</h3>
                    <p className="text-sm text-gray-200">{photo.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PhotoGallery;
